<template>
  <div class="su-accordion" v-if="items && items.length">
    <v-card outlined class="su-card">
      <div class="su-header" @click="toggleAccordion" style="cursor:pointer;">
        <div class="su-title">{{ statusHeader }}</div>
        <div class="su-actions">
          <v-btn icon small @click.stop="toggleAccordion">
            <v-icon>{{ internalCollapsed ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="su-list" v-show="!internalCollapsed">
        <div v-for="it in items" :key="it.id" class="su-item">
          <div class="su-thumb-wrap">
            <v-img :src="it.thumb || require('@/styles/test thmnail.png')" contain class="su-thumb" />
          </div>  
          
          <div class="su-meta">
            <div class="su-title-line" :title="it.title">{{ it.title }}</div>
            <div class="su-sub">
              <v-img :src="platformImageSource(it.platform)" width="14" height="14" contain class="mr-1" style="display:inline-block;vertical-align:middle;" />
              <span style="vertical-align:middle;">{{ platformLabel(it.platform) }}</span>
            </div>
            <div class="su-progress-rail">
              <div class="su-progress-bar" :style="{ width: (it.progress || 0) + '%' }"></div>
            </div>
          </div>
          <div class="su-right">
            <div class="su-pct">
              <template v-if="isCompleted(it)">
                <v-icon x-small color="#1e88e5" class="mr-1">mdi-check-circle</v-icon>
                100%
              </template>
              <template v-else>
                {{ it.progress || 0 }}%
              </template>
            </div>
            <v-btn
              v-if="isCompleted(it)"
              icon
              small
              @click="onAskHide(it)"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-btn
              v-else
              icon
              small
              @click="onCancel(it)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="su-btn">
        <TextButton
          :small="true"
          :buttonText="$store.getters.t ? $store.getters.t('social.upload.status_panel.hide_all') : '내역 전체 숨기기'"
          :loading="bulkHiding"
          @click="onHideAll"
        />
        <TextButton 
          :small="true" 
          :buttonText="toggleButtonLabel" 
          :loading="updateLoading" 
          @click="updateInfo()"/>
      </div>
    </v-card>

    <AppDialog v-model="confirmOpen" >
      <template v-slot:title>
          <span>{{ $store.getters.t('social.upload.status_panel.dialog.title') }}</span>
      </template>
      <template v-slot:content>
        <span>{{ $store.getters.t('social.upload.status_panel.dialog.message') }}</span>
      </template>
      <template v-slot:actions>
        <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" @click="confirmOpen=false" />
        <TextButtonBlock :loading="tbloading" :buttonText="$store.getters.t ? $store.getters.t('social.upload.status_panel.dialog.hide_button') : '숨기기'" @click="confirmHide" isPrimary />
      </template>
    </AppDialog>
  </div>
</template>

<script>
import AppDialog from '@/components/app/AppDialog.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';

export default {
  name: 'SocialUploadStatusAccordion',
  components: { AppDialog, TextButtonBlock, TextButton },
  props: {
    items: { type: Array, default: () => [] },
    pausedAll: { type: Boolean, default: false },
    collapsed: { type: Boolean, default: false },
    bulkHiding: { type: Boolean, default: false },
  },
  data() { 
    return { 
      confirmOpen: false, 
      pendingHideId: null,
      internalCollapsed: this.collapsed,
      tbloading: false,
    }; 
  }, 
  computed: { 
    statusHeader() {
      const title = this.$store.getters.t
        ? this.$store.getters.t('social.upload.status_panel.title')
        : '소셜 전송 현황';
      const unit = this.$store.getters.t
        ? this.$store.getters.t('common.unit.items')
        : '개';
      return `${title} (${this.items.length}${unit})`;
    },
    toggleButtonLabel() {
      if (this.pausedAll) {
        return this.$store.getters.t
          ? this.$store.getters.t('social.upload.status_panel.toggle.resume_all')
          : '다시시작';
      }
      return this.$store.getters.t
        ? this.$store.getters.t('social.upload.status_panel.toggle.pause_all')
        : '전체 일시정지';
    }
  },
  watch: {
    collapsed(val) {
      this.internalCollapsed = val;
    }
  },
  methods: {
    platformImageSource(platform) {
      const key = (platform || '').toLowerCase();
      return key.includes('inst')
        ? require('@/styles/instgram.png')
        : require('@/styles/youtube.png');
    },
    platformLabel(platform) {
      const key = (platform || '').toLowerCase();
      if (key.includes('inst')) {
        return this.$store.getters.t
          ? this.$store.getters.t('social.upload.platform.instagram')
          : 'Instagram';
      }
      return this.$store.getters.t
        ? this.$store.getters.t('social.upload.platform.youtube')
        : 'YouTube';
    },
    toggleAccordion() {
      const next = !this.internalCollapsed;
      this.internalCollapsed = next;
      this.$emit('update:collapsed', next);
      this.$emit('toggle', next);
    },
    isCompleted(item) {
      return (Number(item.progress) || 0) >= 100
        || ['done', 'completed', 'failed'].includes(item.status);
    },
    onAskHide(it) {
      if (!this.isCompleted(it)) return;
      this.pendingHideId = it.id;
      this.confirmOpen = true;
    },
    onCancel(it) {
      if (!it || !it.id) return;
      this.$emit('cancel', it.id);
    },
    confirmHide() {
      if (this.pendingHideId) this.$emit('hide', this.pendingHideId);
      this.pendingHideId = null;
      this.confirmOpen = false;
    },
    onHideAll() {
      if (this.bulkHiding) return;
      this.$emit('hide-all');
    },
    updateInfo() {
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.su-accordion {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 1000;
  width: 360px;
}
.su-card { border-radius: 10px; }
.su-header { display:flex; align-items:center; justify-content: space-between; padding: 8px 12px; }
.su-title { font-weight: 800; font-size: 14px; }
.su-list { max-height: 320px; overflow: auto; padding: 8px 12px; }
.su-item { display:flex; align-items:center; gap:10px; padding: 8px 0; }
.su-thumb-wrap { width: 107px; height: 60px; }
.su-thumb { border-radius: 6px; height: 100%; }
.su-meta { flex:1; min-width:0; }
.su-title-line { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 600; font-size: 14px; }
.su-sub { font-size: 12px; color: #6b7280; }
.su-progress-rail { height: 6px; background: #f3f4f6; border-radius: 999px; overflow: hidden; margin-top: 6px; }
.su-progress-bar { height: 6px; background: #3b82f6; }
.su-right { display:flex; flex-direction: column; align-items: flex-end; gap: 2px; }
.su-pct { font-size: 12px; color: #374151; display: flex; gap: 2px; }
.su-btn { padding: 8px 12px;border-top: 1px solid #ccc; display: flex; justify-content: flex-end; gap: 8px; flex-wrap: wrap; }
</style>
